import styled, { BoxShadows, Scale, boxShadows } from '@secretescapes/falcon';
import { mediaQuery } from '@utils/styles.utils';

export const Tabs = styled('div')`
  display: flex;

  @media ${mediaQuery.tablet}, ${mediaQuery.desktop} {
    border: ${({ theme }) => `${theme.color.grey10} 1px solid`};
    border-style: solid solid none;
    border-radius: ${Scale.xxs} ${Scale.xxs} 0 0;
    box-shadow: ${boxShadows[BoxShadows.level2]};
    /* Negative margin to hide the overlapping border */
    margin-bottom: -1px;
    width: fit-content;
  }
`;

export const TabsSkeleton = styled(Tabs)`
  width: 100%;

  @media ${mediaQuery.tablet}, ${mediaQuery.desktop} {
    width: 45%;
  }
`;

interface TabSkeletonProps {
  borderRadiusPosition?: 'left' | 'right';
}

export const TabSkeleton = styled('div')<TabSkeletonProps>`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: ${Scale.xs};
  padding: ${Scale.s} ${Scale.l};
  cursor: pointer;
  background-color: ${({ theme }) => theme.color.white};

  :last-child {
    border-bottom: ${({ theme }) => theme.color.grey10} 1px solid;
    border-left: ${({ theme }) => theme.color.grey10} 1px solid;
  }

  ${({ borderRadiusPosition }) =>
    borderRadiusPosition && `border-top-${borderRadiusPosition}-radius: ${Scale.xxs}`}
`;
